import {Box, TextField, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import React, {useEffect, useState} from 'react';
import {useProfile} from "crqlar-react-common/dist/utils/hooks/profile/useProfiles";
import {ReservationStatus} from "crqlar-react-common/dist/models/reservation/reservation.model";
import {getCurrentStay} from "crqlar-react-common/dist/models/profile/profile.model";
import {FOLIO_FIELD_GAP} from "../editor/folioStyles";

interface AsaProviderProps {
    onDataChange: (isValid: boolean, data: any) => void;
    profileId?: string;
    /** The folio dialog's payment block: a small field, no title repeating the chosen payment method. */
    compact?: boolean;
}

const AsaProvider = ({profileId, onDataChange, compact}: AsaProviderProps) => {
    const {t} = useTranslation();

    // States for form data
    const profile = useProfile(profileId);

    const [roomId, setRoomId] = useState('');
    // const [externalUserId, setExternalUserId] = useState('');

    // Validate form and pass data to parent
    useEffect(() => {
        const isValid = !!roomId // && !!externalUserId;

        const data = {
            roomId,
            // externalUserId,
            provider: 'asa'
        };

        console.log("Trigger data change", isValid, data);
        onDataChange(isValid, data);
    }, [roomId]);

    useEffect(() => {
        if (profile?.id && !roomId) {
            console.log(profile.activeStays)
            setRoomId(getCurrentStay(profile)?.roomId || '')
        }
    }, [profile?.id]);

    return (
        <Box
            sx={{
                gap: compact ? FOLIO_FIELD_GAP : '12px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            {!compact && (
                <Typography>
                    {t('ASA Provider Configuration')}
                </Typography>
            )}

            <TextField
                fullWidth
                size={compact ? 'small' : undefined}
                label={t('Room ID')}
                value={roomId}
                onChange={(e) => setRoomId(e.target.value)}
                required
            />

            {/*<TextField*/}
            {/*  fullWidth*/}
            {/*  label={t('External User ID')}*/}
            {/*  value={externalUserId}*/}
            {/*  onChange={(e) => setExternalUserId(e.target.value)}*/}
            {/*  required*/}
            {/*/>*/}
        </Box>
    );
};

export default AsaProvider;
